const PostsType = {
  NEWS: { param: 'NEWS', path: '/posts/tin-tuc', name: 'Tin Tức' },
  EVENT: { param: 'EVENT', path: '/posts/su-kien', name: 'Sự kiện' },
  TUTORIAL: { param: 'TUTORIAL', path: '/posts/huong-dan', name: 'Hướng Dẫn' },
  FEATURE: { param: 'FEATURE', path: '/posts/tinh-nang', name: 'Tính Năng' },
};

export const PostsTypeArr = [
  { param: 'NEWS', path: '/posts/tin-tuc', name: 'Tin Tức' },
  { param: 'EVENT', path: '/posts/su-kien', name: 'Sự kiện' },
  { param: 'TUTORIAL', path: '/posts/huong-dan', name: 'Hướng Dẫn' },
  { param: 'FEATURE', path: '/posts/tinh-nang', name: 'Tính Năng' },
];

export const getCurrentPostsType = (pathName: string) => {
  const postType = PostsTypeArr.find(e => e.path === pathName)
  return postType ? postType : PostsType.NEWS;
}

export default PostsType;
